// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__Ju7wk","card":"Card_card__M85Q9"};